import { Router, UrlTree } from '@angular/router';

export function loginRedirectTo(router: Router, attemptedUrl: string): UrlTree {
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: attemptedUrl } });
}
